import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { WidgetHostService } from 'app/shared/widget/widget-host-service';
import { WidgetReportItem } from 'app/shared/widget/widget-item';
import { WidgetHostDirective } from 'app/shared/widget/widget-host.directive';
import { BankRateCalculationResultComponent } from 'app/calculators/home-loan-comparison-calculator/bank-rate-calculation-result/bank-rate-calculation-result.component';
import { CalculatorService } from 'app/calculators/calculator.service';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { HttpService } from 'app/shared/services/http.service';
import * as emiGlobals from 'app/globals';
import { OwlCarousel } from 'ng2-owl-carousel';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApplyLoanModelPopupComponent } from "app/loan/apply-loan-model-popup/apply-loan-model-popup.component";
import { ApplyLoanPopUpComponent } from "app/calculators/home-loan-comparison-calculator/apply-loan-pop-up/apply-loan-pop-up.component";
import {ActivatedRoute, Router} from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { QuestionCategory } from 'app/globals';
import { ProductOffer } from 'app/calculators/Product';



import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import { max } from 'rxjs/operator/max';
// import { Label } from 'ng2-charts';
@Component({
  selector: 'app-bank-rate-calculation',
  templateUrl: './bank-rate-calculation.component.html',
  styleUrls: ['./bank-rate-calculation.component.css']
})
export class BankRateCalculationComponent implements OnInit {

  @ViewChild('bank', { read: WidgetHostDirective }) bank;
  offerList: any;
  i = 0;
  Heighlights: FormGroup;
  Withdraw: FormGroup;
  RecurringForm: FormGroup;
  changeInRate: FormGroup;

  productOffer: ProductOffer = new ProductOffer();


  partPaymentArray: any;
  dataList: any;
  offer = [];
  principalList: any;
  tenure: any;
  amoritizationList: any;
  selectedProduct: any;
  ppr: any;
  active: any;
  SearchCategory: any;
  taxList: any;
  loanEligibilty: any;
  finalLoanEligibilty: any;
  buttonBasedOnProduct: any;
  activeButton: any;
  leadOffer: any;
  detailsList: any;
  amoritization: any;
  withdraw: any;
  showWithdraw: any;
  encodedurl: any;

  showTenure: boolean;
  partPayment: boolean;
  preclosure: any;
  totalcost: boolean;
  defaultOffer: boolean;
  showTaxBenefit: any;
  reduceEmi: boolean;
  reduceTenure: boolean;
  showRate: boolean;
  showSpecificMonthPartPayment: boolean;
  showRecurringPartPayment: boolean;
  showPartPayment: boolean;
  showPreClosure: boolean;
  changeInRates: boolean;
  viewmoreData = false;

  valueList = [];
  pprArray = [];
  barchartdata = [];

  currentvalues: any;

  public url: string = "";
  domain: any;


  public lineChartData: Array<number> = [];
  public labelMFL: Array<any> = [
    {
    

      data: this.lineChartData,
      // label: this.SystemName
      
    }
    
  ];
  
  // labels
  public lineChartLabels: Array<any> = ['Processing Fees', 'Pre-Closure', 'Total Interest'];


  @ViewChild('owlElement') owlElement: OwlCarousel;
  @Input() inputvalue;

  
  // bar chart

  public barChartOptions: ChartOptions = {
    responsive: true,
  };
  // public barChartLabels: Label[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartDataset[] = [
    // { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    // { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  ];


  constructor(public widgetHostService: WidgetHostService,
    public calculatorService: CalculatorService, private fb: FormBuilder, public httpService: HttpService,
    private modalService: NgbModal, private activatedRoute: ActivatedRoute,
    private router: Router, location: Location,private datePipe: DatePipe
     ) { 
      this.url = this.router.url;
      this.url = location.path();
    }

  ngOnInit() {
   // alert(JSON.stringify(this.inputvalue))
    // this.calculatorService.clearCurrentData();
    this.activatedRoute.data.subscribe(({ lead }) => {
      // do something with your resolved data ...
    })
    console.log('----------1111111111-lable-----' , this.lineChartData);
    let portalInfo = localStorage.getItem('portalInfo');
    this.domain = JSON.parse(portalInfo).subdomain + '.eloan.loan' ;
    this.encodedurl = encodeURIComponent(this.url);
    this.url  =  this.domain + this.encodedurl;
    this.offer =  [];

    this.calculatorService.currentData.subscribe(result => {
      if (result !== 'default') {
        this.dataList = result;
        this.dataList.questionAnswer.forEach(element => {
          if (element.category_id === QuestionCategory.loanAmount) {
          this.productOffer.loanAmount = element.value;
          }
        });
      }
    });
    // this.calculatorService.defaultOffer = false;
    const compny = this.activatedRoute.snapshot.params.company;
    const firstParam: string = this.activatedRoute.snapshot.queryParamMap.get('company');
    this.activatedRoute.queryParams.subscribe(params => {
     this.productOffer.product = params['product'];
     this.productOffer.loanAmount = params['loanAmount'];
     this.productOffer.companyName = params['company'];
     this.productOffer.salary = params['salary'];
     this.productOffer.tenure = params['tenure'];
     this.productOffer.salaryAccountBank = params['salary_bank_id'];
     this.productOffer.residencyId = params['residencyId'];
      this.productOffer.contactNumber  = params['number'];
      this.productOffer.bankId = params['bankId'];
      this.productOffer.leadId = params['leadId'];

      this.activatedRoute.queryParams.subscribe(params => {
        this.productOffer.leadId = params['leadId'];
        if (this.productOffer.leadId) {
          debugger
         this.httpService.getAll(emiGlobals.getLeadDetailsById + '/' + this.productOffer.leadId).subscribe(
           result => {
             this.productOffer.email = result.leads[0].email;
             this.productOffer.contactNumber = result.leads[0].contact_number;
             this.productOffer.name = result.leads[0].name;
           }
         )
       }
 
     });

  
     this.getLeadOffers( this.productOffer.product, this.productOffer.loanAmount, 
      this.productOffer.salary, this.productOffer.tenure, this.productOffer.companyName,
      this.productOffer.salaryAccountBank, this.productOffer.residencyId, this.productOffer.bankId);
    });
   this.currentvalues  =  this.calculatorService.currentValues.subscribe(result => {
      console.log('----BankRateCalculationCompone333-', result);
      this.offerList = result;
      if (result !== 'default') {
        this.offer =  [];
        if (result['offers']) {
          this.offer = result['offers'];
          this.calculatorService.inputValues  =  result['inputValues'];
          this.calculatorService.offer = this.offer;
          this.calculatorService.loading = false;
          console.log('----BankRateCalculationCompone333new-',  this.calculatorService.offer.length );
          // if (this.offer.length <= 1) {
          //   this.calculatorService.noOffer = true;
          // } else  {
          //   this.calculatorService.noOffer = false;
          // }
          this.offer.forEach(element => {
            if (element.filter) {
              this.buttonBasedOnProduct = element.filter.split(',');
            }
          });
        }
        this.amoritizationList = result['principal'];
      }
    });
   
    this.calculatorService.currentLoanEligibility.subscribe(result => {
      console.log('----BankRateCalculationComponent6666--', result);
      if (result !== 'default') {
        this.loanEligibilty = result;
      }
    });
    this.Heighlights = this.fb.group({
      itemRows: this.fb.array([this.initItemRows()]), // here
      'amnt': ['', Validators.compose([Validators.required])],
      'option': ['', Validators.compose([Validators.required])],
    });
    this.Withdraw = this.fb.group({
      itemRows: this.fb.array([this.initItemRows()])
    });

    this.RecurringForm = this.fb.group({
      'amnt': ['', Validators.compose([Validators.required])],
      'option': ['', Validators.compose([Validators.required])]
    });

    this.changeInRate = this.fb.group({
      itemRows: this.fb.array([this.initItemRows()]), // here
    });
  }


  tabledata() {
    this.viewmoreData = !this.viewmoreData;

  }

  // carousel for tax savings

  owl(action) {
    switch (action) {
      case 'prev':
        this.owlElement.previous();
        break;
      case 'next':
        this.owlElement.next([200]);
        break;
    }
  }


  initItemRows() {
    return this.fb.group({
      // list all your form controls here, which belongs to your form array
      key: [''],
      value: ['']
    });
  }

  // dynamically add new row 
  addNewRow() {
    if (this.i < 3) {
      const control = <FormArray>this.Heighlights.controls['itemRows'];
      this.Heighlights.controls['itemRows'].value
      // add new formgroup
      control.push(this.initItemRows());
    }
    this.i++;
  }
  addNewRowForRate() {
    if (this.i < 3) {
      const control = <FormArray>this.changeInRate.controls['itemRows'];
      this.changeInRate.controls['itemRows'].value
      // add new formgroup
      control.push(this.initItemRows());
    }
    this.i++;
  }

  // on submit of part payment
  submit(value, offer) {
    this.productOffer.partPayment.length = 0;
    this.reduceEmi = false;
    this.partPaymentArray = value.itemRows;
    this.partPaymentArray.forEach(element => {


      // For Lead Offer
      if (this.dataList === undefined) {
        this.productOffer.questionAnswer = [{
          'id': '',
          'value': this.productOffer.loanAmount,
          'category_id': QuestionCategory.loanAmount
        },
        {
          'id': '',
          'value': this.productOffer.salary,
          'category_id': QuestionCategory.salary
        },
        {
          'id': '',
          'value': this.productOffer.tenure,
          'category_id': QuestionCategory.tenure
        }]
      } else {
        this.productOffer.product = <ProductOffer>this.dataList.product;
        this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
        this.productOffer.questionSetId = <ProductOffer>this.dataList.questionSetId;
      }
      this.principalList = 0;
   
      this.productOffer.partPaymentMonth = element.key;
      this.productOffer.partPaymentAmount = element.value;
      this.productOffer.partPayment = value.itemRows;
   
      this.productOffer.roi = offer.ROI;
      this.productOffer.partPaymentRate = offer.partPaymentRate;
      this.productOffer.bankId = offer.BankId;
        this.httpService.create(emiGlobals.PartPaymentUrl, this.productOffer).subscribe(result => {
          const value = JSON.parse(result._body);
          this.showTenure = true;
          this.partPayment = true;
          this.reduceTenure = true;
          this.amoritization = false;
          // this.withdraw = '6' + offer.BankId ;
          this.principalList = value;
        });

    });

  }

  // To display new tenure
  onChangeOf(bankId) {
    if (this.principalList !== undefined) {
      this.principalList.forEach(data => {
        if (data.BankId === bankId) {
          if (data.ClosingBalance <= 0) {
            this.tenure = data.NewTenure;
          }
        }
      });
    }
    return this.tenure;
  }

  // To Display new Emi
  newEmi(bankId) {
    if (this.principalList !== undefined) {
      this.principalList.forEach(data => {
        if (data.BankId === bankId) {
          if (data.NewEMI !== 0) {
            this.tenure = data.NewEMI;
          }
        }
      });
    }
    return this.tenure;
  }

  // To get Original EMI
  originalEmi(bankId) {
    if (this.principalList !== undefined) {
      this.principalList.forEach(data => {
        if (data.BankId === bankId) {
          if (data.NewEMI === 0) {
            this.productOffer.originalEmi = data.Emi + data.ReducedEmi;
          }
        }
      });
    }
    return this.productOffer.originalEmi;
  }

  // To get Original Tenure
  originalTenure(bankId) {
    if (this.principalList !== undefined) {
      this.principalList.forEach(data => {
        if (data.BankId === bankId) {
          this.productOffer.outstandingTenure = data.outstandingTenure;
        }
      });
    }
    return this.productOffer.outstandingTenure;
  }

  // To get Reduced Tenure
  reducedTenure(bankId) {
    if (this.principalList !== undefined) {
      this.principalList.forEach(data => {
        if (data.BankId === bankId) {
          if (data.reducedTenure !== 0) {
            this.productOffer.reducedTenure = data.reducedTenure;
          }
        }
      });
    }
    return this.productOffer.reducedTenure;
  }

  // To calculate total savings 
  totalsavingsinEMIforremainingtenure(bankId) {
    if (this.principalList !== undefined) {
      this.principalList.forEach(data => {
        if (data.BankId === bankId) {
          if (data.totalsavingsinEMIforremainingtenure !== 0) {
            this.productOffer.savingsInEmi = data.totalsavingsinEMIforremainingtenure;
          }
        }
      });
    }
    return this.productOffer.savingsInEmi;
  }

   // To get Reduced Emi
  reducedEmi(bankId) {
    if (this.principalList !== undefined) {
      this.principalList.forEach(data => {
        if (data.BankId === bankId) {
          if (data.ReducedEmi !== 0) {
            this.productOffer.ReducedEmi = data.ReducedEmi;
          }
        }
      });
    }
    return this.productOffer.ReducedEmi;
  }
  

  // amoritization

  onClickOfAmoritization(offer, view) {
    this.onTabClick (4, offer.BankId);
    this.showTaxBenefit = 't' + offer.BankId;
    this.partPayment = false;
    this.totalcost = false;
    this.preclosure = false;
    this.showWithdraw = false;
    this.showTaxBenefit = false;
    this.amoritization =  'a' +  offer.BankId;
    this.showRate = false;
    this.activeButton = '4';


    if (this.dataList === undefined) {
      this.productOffer.questionAnswer = [{
        'id': '',
        'value': this.productOffer.loanAmount,
        'category_id': QuestionCategory.loanAmount
      },
      {
        'id': '',
        'value': this.productOffer.salary,
        'category_id': QuestionCategory.salary
      },
      {
        'id': '',
        'value': this.productOffer.tenure,
        'category_id': QuestionCategory.tenure
      }]
    } else {
      this.productOffer.product = <ProductOffer>this.dataList.product;
      this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
      this.productOffer.questionSetId = <ProductOffer>this.dataList.questionSetId;
    }
  

    this.productOffer.roi = offer.ROI;
    this.productOffer.partPaymentRate = offer.partPaymentRate;
    this.productOffer.bankId = offer.BankId;
    this.httpService.create(emiGlobals.amoritizationtUrl, this.productOffer).subscribe(
      result => {
        if (view === 1) {
          this.amoritizationList =  JSON.parse(result._body).principalyearwise;
        } else {
          this.amoritizationList =  JSON.parse(result._body).principal;
        }
      }
    );
  }

 
  // onChangeOfPrincipal(bankId) {
  //   this.valueList.length = 0;
  //   this.amoritizationList.forEach(element => {
  //     if (element.BankId === bankId) {
  //       this.valueList.push(element);
  //     }
  //   });
  //   return this.valueList;
  // }
  onChangeOfPartPayment(bankId) {
    
    this.amoritization = false;
    this.valueList.length = 0;
    this.principalList.forEach(element => {
      if (element.BankId === bankId) {
        if (element.ClosingBalance >= 0) {
          this.valueList.push(element);
        }
      }
    });
    return this.valueList;
  }

  // to make active class
  onClickOfFilter(value) {
    this.selectedProduct = value;
  }

  // pre closure
  preClosureCalculation(offer) {
    
    this.showWithdraw = false;
    this.showTaxBenefit = false;
    this.productOffer.pcr = this.ppr;
    this.productOffer.product = <ProductOffer>this.dataList.product;
    this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
    this.productOffer.listType = <ProductOffer>this.dataList.listType;
    this.productOffer.locationId = <ProductOffer>this.dataList.locationId ;
    this.productOffer.companyName = <ProductOffer>this.dataList.companyName;
    this.productOffer.salaryAccountBank = <ProductOffer>this.dataList.salaryAccountBank;
    this.productOffer.currentDate = <ProductOffer>this.dataList.currentDate;
    this.productOffer.residencyId = <ProductOffer>this.dataList.residencyId;
    console.log('--this.productOffer.currentDate ' , this.productOffer.currentDate );
    // this.httpService.create(emiGlobals.productOfferUrl + '/' +
    //   this.productOffer.product, this.productOffer).subscribe(result => {
    //     const value = JSON.parse(result._body);
    //     this.calculatorService.getCurrentData(value);
    //     this.preclosure = offer.bankId;
    //   });

    if (this.productOffer.listType === 1) {
      console.log('ssssssssssssssssssss');
      if (this.productOffer !== undefined) {
        this.httpService.create(emiGlobals.companySpecificOfferUrl, this.productOffer).subscribe(result => {
          const value = JSON.parse(result._body);
          this.calculatorService.offer = value.offers;
          this.calculatorService.getCurrentData(value);
          this.calculatorService.getInputData(this.productOffer);
          this.preclosure = 'p' + offer.BankId ;
        });
      }
    } else { // for home loan
      if (this.productOffer !== undefined) {
        this.productOffer.status = 1;
        this.httpService.create(emiGlobals.productOfferUrl, this.productOffer).subscribe(result => {
          const value = JSON.parse(result._body);
          this.productOffer.offer = value;
          this.calculatorService.getCurrentData(value);
          this.calculatorService.getInputData(this.productOffer);
          this.preclosure = 'p' + offer.BankId ;
        });
      }
    }

      // this.httpService.create(emiGlobals.companySpecificOfferUrl , this.productOffer).subscribe(result => {
      //   const value = JSON.parse(result._body);
      //   this.calculatorService.getCurrentData(value);
      //   this.preclosure = 'p' + offer.BankId ;
      //   console.log('-----shsdsdaduud' , this.preclosure);
      // });
  }

  // total costs
  onClickOfTotalCosts(tabId) {
    this.showTaxBenefit = false;
    this.totalcost = true;
    this.SearchCategory = tabId;

    this.lineChartData.length = 0;
    this.SearchCategory = tabId;
    this.onTabClick('3', this.offerList.offers[0].BankId);
  }
  OnSubmitOfWithdrawal(value, offer) {
    this.partPayment = false;
    this.partPaymentArray = value.itemRows;
    this.partPaymentArray.forEach(element => {
      this.productOffer.withdrawalAmount = element.value;
      this.productOffer.withdrawalMonth = element.key;
      this.productOffer.roi = offer.ROI;
      this.productOffer.bankId = offer.BankId;
      this.httpService.create(emiGlobals.productOfferForWithdraw , this.productOffer).subscribe(result => {
          const value = JSON.parse(result._body);
          this.showTenure = true;
          this.showWithdraw = 'w' + offer.BankId;
          this.principalList = value.principal;
        });

    });
  }
  onChangeOfWithdraw(bankId) {
    this.valueList.length = 0;
    if (this.principalList) {
      this.principalList.forEach(element => {
        if (element.BankId === bankId) {
          this.valueList.push(element);
        }
      });
    }
    return this.valueList;
  }
  onClickOfTaxBenefit(offer, tabId) {
    this.SearchCategory = false;
    this.showTaxBenefit = 't' + offer.BankId;
    this.partPayment = false;
    this.totalcost = false;
    this.preclosure = false;
    this.amoritization = false;
    this.productOffer.product = <ProductOffer>this.dataList.product;
    this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
    this.productOffer.roi = offer.ROI;
    this.productOffer.bankId = offer.BankId;
    this.activeButton = tabId;
    this.httpService.create(emiGlobals.productOfferForWithdraw , this.productOffer).subscribe(result => {
        const value = JSON.parse(result._body);
        this.taxList = value.table;
      });
  }
  showOfferBasedOnSavings(value: number, maxInterest) {
    this.productOffer.taxRate = value;
    this.productOffer.taxSavings = value * maxInterest / 100;
  }
  onTabClick(tabId, bankId) {
    this.showPartPayment = tabId + bankId;
    this.showSpecificMonthPartPayment = tabId + bankId;
    this.showRecurringPartPayment = tabId + bankId;
    this.showPreClosure = tabId + bankId;
    this.partPayment = false;
    this.reduceTenure = false;
    this.showTaxBenefit = false;
    this.withdraw = tabId + bankId;
    this.changeInRates = tabId + bankId;
    // if (tabId === '1' ) {
    //   this.showPartPayment = tabId + bankId;
    //   this.showPreClosure = tabId + bankId;
    // } else if (tabId === '2') {
    //   this.showPreClosure = true;
    //   this.showPartPayment = false;
    //   this.showSpecificMonthPartPayment = false;
    // } else {
    //   this.showPartPayment = false;
    //   this.showPreClosure = false;
    //   this.showSpecificMonthPartPayment = false;
    // }
    this.activeButton = tabId;
    this.lineChartData.length = 0;
    this.SearchCategory = tabId + bankId;
    this.amoritization = false;
    this.calculatorService.offer.forEach(offer => {
      
      if (offer.BankId === bankId) {
        this.barChartData = [];
        const pf = Math.round((offer.PF / offer.totalCost) * 100);
        const pc = Math.round((offer.preClosureCost / offer.totalCost) * 100);
        const ti = Math.round((offer.TotalInterest / offer.totalCost) * 100);
        const cs = offer.mincibil + ' to ' + offer.maxcibil;
        
        this.lineChartData.push(pf, pc, ti);

        this.barChartData.push({
          data: [pf] ,
          label: 'Processing Fees'
        },{
          data: [pc],
          label: 'Pre-Closure',
        },{
          data: [ti],
          label: 'Total Interest'
        })
      }
    });
  }
  partPaymentPenalty(bankId) {
    this.principalList.forEach(partPayment => {
      this.productOffer.penalty = partPayment.partPaymentPenalty;
    });
    return this.productOffer.penalty;
  }
  onChangeOfTax(bankId) {

    this.valueList.length = 0;
    this.taxList.forEach(element => {
      if (element.bankId === bankId) {
        this.valueList.push(element);
      } 
    });

    return this.valueList;
  }
 

  onSubmitOfRecuring(value, offer) {
    this.productOffer.partPayment.length = 0;
    this.productOffer.product = <ProductOffer>this.dataList.product;
    this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
    this.productOffer.recurringAmount = value.amnt;
    this.productOffer.recurringMonth = value.option;
    this.productOffer.bankId =  offer.BankId;
    this.productOffer.roi = offer.ROI;
    this.httpService.create(emiGlobals.recurringPartPaymentUrl, this.productOffer).subscribe(result => {
        const value = JSON.parse(result._body);
        this.showTenure = true;
        this.partPayment = true;
        this.amoritization = false;
        this.showWithdraw = false;
        this.principalList = value.principal;
        // this.principalList.forEach(data => {
        //   this.tenure =   data.NewTenure;
        // });

      });

    // to handle condition like hide and show based on ppm validation
    // this.productOffer.partPaymentMonth = value.option;
    // this.productOffer.partPaymentAmount = value.amnt;
    // this.productOffer.partPayment.push({
    //   'key': value.option,
    //   'value': value.amnt
    // });
    // this.httpService.create(emiGlobals.productOfferUrl + '/' +
    //   this.productOffer.product, this.productOffer).subscribe(result => {
    //     const value = JSON.parse(result._body);
    //     this.calculatorService.getCurrentData(value);
    //   });
    //   this.onTabClick('1', this.offerList.products[0].BankId);

  }

  public lineChartOptions: any = {
    responsive: true,
    scales: {
    },
  };

  _lineChartColors: Array<any> = [{
    backgroundColor: 'red',
    borderColor: 'red',
    pointBackgroundColor: 'red',
    pointBorderColor: 'red',
    pointHoverBackgroundColor: 'red',
    pointHoverBorderColor: 'red'
  }];



  public lineChartType = 'bar';

  public chartClicked(e: any): void {
    console.log(e);
  }
  public chartHovered(e: any): void {
    console.log(e);
  }
  toChangeEMI(value) {
    this.partPaymentArray = value.itemRows;
    console.log('c this.partPaymentArray', this.partPaymentArray);
    this.partPaymentArray.forEach(element => {

      // For lead offer

      if (this.dataList === undefined) {
        this.productOffer.questionAnswer = [{
          'id': '',
          'value': this.productOffer.loanAmount,
          'category_id': QuestionCategory.loanAmount
        },
        {
          'id': '',
          'value': this.productOffer.salary,
          'category_id': QuestionCategory.salary
        },
        {
          'id': '',
          'value': this.productOffer.tenure,
          'category_id': QuestionCategory.tenure
        }]
      } else {
        this.productOffer.product = <ProductOffer>this.dataList.product;
        this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
        this.productOffer.questionSetId = <ProductOffer>this.dataList.questionSetId;
        const myDate = new Date();
        this.productOffer.currentDate = this.datePipe.transform(myDate, 'yyyy-MM-dd');
      }
      this.principalList = 0;
      this.productOffer.partPayment = value.itemRows;
      this.httpService.create(emiGlobals.partPaymentByReducedEmiUrl, this.productOffer).subscribe(result => {
        const value = JSON.parse(result._body);
        this.showTenure = true;
        this.partPayment = true;
        this.reduceTenure = false;
        this.reduceEmi = true;
        this.amoritization = false;
        this.withdraw = true;
        this.principalList = value.principal;
        // this.principalList.forEach(data => {
        //   this.tenure =   data.NewTenure;
        // });

      });
      // to handle condition like hide and show based on ppm validation

      this.httpService.create(emiGlobals.productOfferUrl + '/' +
        this.productOffer.product, this.productOffer).subscribe(result => {
          const value = JSON.parse(result._body);
          this.calculatorService.getCurrentData(value);
        });
      // this.onTabClick('1', this.offerList.products[0].BankId);
    });

  }
  onChangeOfRate(value, offer) {
    this.productOffer.product = <ProductOffer>this.dataList.product;
    this.productOffer.changeInRate = value.itemRows;
    this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
    this.productOffer.questionSetId = <ProductOffer>this.dataList.questionSetId;
    this.productOffer.roi = offer.ROI;
    this.productOffer.bankId = offer.BankId;
    this.httpService.create(emiGlobals.changeInRateUrl, this.productOffer).subscribe(result => {
      const value = JSON.parse(result._body);
      this.amoritizationList = value.principal;
      this.showRate = true;
      this.amoritization = offer.BankId;;
    });
  }
  onChangeOfPartPaymentOption(value, bankId) {
    if (Number(value) === 11) {
      this.activeButton = 11;
      this.showSpecificMonthPartPayment = value + bankId;
      this.showRecurringPartPayment = value + bankId;
    } else {
      this.activeButton = 22;
      this.showRecurringPartPayment = value + bankId;
      this.showSpecificMonthPartPayment = value + bankId;
    }
  }
  // calculateLoanEligibilty(bankId) {
  //   if (this.loanEligibilty !== 'default') {
  //     if (this.loanEligibilty) {
  //       this.loanEligibilty.forEach(value => {
  //         if (value.BankId === bankId) {
  //           this.finalLoanEligibilty = value.loanEligibilty;
  //         } else {
  //           this.finalLoanEligibilty = '';
  //         }
  //       });
  //     }
  //   }
  //   return this.finalLoanEligibilty;
  // }

  calculateLoanEligibilty(bankId: string): number {
    let totalLoanEligibility = 0;
    let count = 0;
  
    if (this.loanEligibilty !== 'default' && Array.isArray(this.loanEligibilty)) {
      for (let value of this.loanEligibilty) {
        if (value.BankId == bankId) {
          if (typeof value.loanEligibility === 'number') {
            totalLoanEligibility += value.loanEligibility; // Sum loanEligibility
            count++;
          }
        }
      }
    }
  
    return count > 0 ? totalLoanEligibility / count : 0; // Return average or 0 if no entries
  }
  onChangeOfSlider(value) {
    this.productOffer.rangeSliderValue = value;
  }
  onChangeOfSliderValueForAmount(value) {
    this.productOffer.amount = value;
  }

  openThisOffer(offer, lead_type) {
    // this.leadOffer = JSON.parse(localStorage.getItem('lead_offer'));
    // this.leadOffer.bank_interest = offer.ROI;
    // this.leadOffer.emi = offer.EMI;
    // this.leadOffer.processing_fee = offer.PF;
    // this.leadOffer.lead_type = lead_type;
    // this.leadOffer.name  = offer.Bank;
    // this.leadOffer.id = offer.BankId;
    // this.leadOffer.conditions = offer.Conditions;
    // this.leadOffer.offer_type = "default";
    // localStorage.setItem('lead_offer', JSON.stringify( this.leadOffer));

    if (this.dataList === undefined) {
      debugger
      this.productOffer.questionAnswer = [{
        'id': '',
        'value': this.productOffer.loanAmount,
        'category_id': QuestionCategory.loanAmount
      },
      {
        'id': '',
        'value': this.productOffer.salary,
        'category_id': QuestionCategory.salary
      },
      {
        'id': '',
        'value': this.productOffer.tenure,
        'category_id': QuestionCategory.tenure
      }]
    } else {
      debugger
      this.productOffer.product = <ProductOffer>this.dataList.product;
      this.productOffer.questionAnswer = <ProductOffer>this.dataList.questionAnswer;
      this.productOffer.salaryAccountBank = <ProductOffer>this.dataList.salaryAccountBank;
      this.productOffer.residencyId = <ProductOffer>this.dataList.residencyId;
      this.productOffer.companyName = <ProductOffer>this.dataList.companyName;
      this.productOffer.statusId =  <ProductOffer>this.dataList.statusId;
      this.productOffer.statusName =  <ProductOffer>this.dataList.statusName;
      this.productOffer.gender = <ProductOffer>this.dataList.gender;
      this.productOffer.locationId = <ProductOffer>this.dataList.locationId;
      const fullUrl = this.router.url;
      //console.log(fullUrl); // This will print "/calculator/personal"
      this.productOffer.calculatorurl = fullUrl;  

    }
    this.leadOffer = offer;
    const modalRef = this.modalService.open(ApplyLoanPopUpComponent,{ size: 'lg',windowClass:'loan-lead-pop-up' });
    modalRef.componentInstance.offer = this.leadOffer;
    modalRef.componentInstance.inputvalue  = this.productOffer;
    // modalRef.componentInstance.whtasAppNumber=offer.whatsapp_number;
    // modalRef.componentInstance.Messenger=offer.messenger_id;
  }
  onChangeOfOption(value) {
    
  }
  getLeadOffers(product, loanAmount , salary, tenure, company,salary_bank_id , residencyId, bankId) {
    if (loanAmount) {
      this.httpService.getAll(emiGlobals.leadOfferUrl + '/' + product + '/' + loanAmount + 
      '/' + salary + '/' + tenure + '/' + company + '/' + salary_bank_id + '/' + residencyId + 
      '/' + bankId).subscribe(result => {
      this.defaultOffer = true;
      this.offer = result.offers;
      console.log('leadddddddd')
      this.calculatorService.offer = result.offers;
        this.offer.forEach(element => {
            if (element.filter) {
              this.buttonBasedOnProduct = element.filter.split(',');
            }
          });
      });
    }
  }

  onClickOfMoreDetails(view, bankId, id, category)  {
    this.productOffer.listType = <ProductOffer>this.dataList.listType;
    console.log('--- this.productOffer.listType' ,  this.productOffer.listType);
    
    this.onTabClick (10, bankId);
    this.showTaxBenefit = 't' + bankId;
    this.partPayment = false;
    this.totalcost = false;
    this.preclosure = false;
    this.showWithdraw = false;
    this.showTaxBenefit = false;
    this.amoritization = false;
    this.showRate = false;
    this.activeButton = '4';

   this.productOffer.iscategory = category;
   this.httpService.create(emiGlobals.productUploadUrl + '/' + id, this.productOffer).subscribe(result => {
    const value = JSON.parse(result._body);
    this.detailsList = value;
     this.SearchCategory = view + bankId;
   });
   this.activeButton = view;
  }

  formatCurrencyINR(value: number, currencyCode: string = 'INR', symbolDisplay: boolean = true): string {
    if (value === null || value === undefined) return null;
  
    // Manually format the number with Indian grouping
    let formattedValue = Number(value).toFixed(2); // Ensures 2 decimal places
    let parts = formattedValue.split('.');
  
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
  
    // Regex to format the integer part with commas in the Indian numbering system
    let lastThreeDigits = integerPart.substring(integerPart.length - 3);
    let otherDigits = integerPart.substring(0, integerPart.length - 3);
  
    if (otherDigits !== '') {
      lastThreeDigits = ',' + lastThreeDigits;
    }
  
    let regex = /\B(?=(\d{2})+(?!\d))/g;
    let formattedIntegerPart = otherDigits.replace(regex, ',') + lastThreeDigits;
  
    let currencySymbol = currencyCode === 'INR' ? '₹' : currencyCode;
  
   // return symbolDisplay ? `${currencySymbol}${formattedIntegerPart}${decimalPart}` : `${formattedIntegerPart}${decimalPart}`;
   return symbolDisplay ? `${currencySymbol}${formattedIntegerPart}` : `${formattedIntegerPart}`;
  }
  

getOrdinalSuffix(ppm: number): string {
    if (ppm % 100 >= 11 && ppm % 100 <= 13) {
      // Special case for 11th, 12th, 13th
      return `${ppm}th`;
    }
    switch (ppm % 10) {
      case 1:
        return `${ppm}st`;
      case 2:
        return `${ppm}nd`;
      case 3:
        return `${ppm}rd`;
      default:
        return `${ppm}th`;
    }
  }
  

 
}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/bank-rate-calculation/bank-rate-calculation.component.ts